module.exports = __webpack_public_path__ + "img/icon_citizens_wellbeing_perception.d7c78920.svg";